import { Utils } from "../../../../../../../services/utils.service";
import { DataCollection } from "../../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../../infrastructure/enums";
import { TransportData } from "../../../../../../infrastructure/transportdata";


export class AshaEmployeeReportFilterFetchRequest {
    public static readonly FetchRequestType: string = "asha_employee_record_fetch_request";
asha_employee_record_ids: number[] = [];
af_employee_record_ids: number[] = [];
under_supervision_ids: number[] = [];
village_ids: number[] = [];
zone_ids: number[] = [];
district_ids: number[] = [];
block_ids: number[] = [];
phc_ids: number[] = [];
af_post_ids: number[] = [];
af_ids: number[] = [];


    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, AshaEmployeeReportFilterFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

